
import axios from 'axios'
import apiRouter from '../router/api-routes'
import store from '../store'
import router from '../router'
import { translateBackendMessage } from './translate-message'

const http = axios.create({
  baseURL: apiRouter.baseURL
})
http.defaults.headers.common.Authorization = 'Bearer ' + store.getters.loginToken
http.defaults.headers.common['x-api-key'] = '1ab2c3tokd4e5fced61ab2c3d4e5f6'

http.interceptors.request.use(function (request) {
  if (!request.baseURL.indexOf(apiRouter.baseURL)) {
    console.log('owner site')
  } else {
    console.log('other site')
  }
  return request
}, function (error) {
  return error
})

http.interceptors.response.use(function (response) {
  return response.data
}, function (error) {
  const status = error.response ? error.response.status : (error.statusCode || null)
  const data = error.response && error.response.data
  const message = (data && (data.message || data.error)) || ''
  if (status === 401) {
    const isPermissionDenied = /pas admin|n'êtes pas|forbidden|not allowed|permission/i.test(message)
    if (!isPermissionDenied) {
      store.dispatch('IS_LOGOUT')
      if (router.currentRoute.path !== '/login') {
        router.push('/login')
      }
    }
  }
  if (error.response && error.response.data) {
    if (typeof error.response.data.message === 'string') {
      error.response.data.message = translateBackendMessage(error.response.data.message)
    }
    if (typeof error.response.data.error === 'string') {
      error.response.data.error = translateBackendMessage(error.response.data.error)
    }
  }
  return Promise.reject(error.response ||
    { response: { status: status, message: translateBackendMessage(error.message) } })
})

export default http
